import React, { useEffect, useMemo, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import SbActionDropdownButton from '../Buttons/SbActionDropdownButton';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../Buttons/Buttons';
import Select, { components } from 'react-select';
import calendar from '../../assets/images/Dashboard/calendar-icon.svg';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg'
import columnFilter from '../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../assets/images/CustomerManagement/valueFilter.svg'
import AddSLA from './AddSLA';
import UpdatedViewDetails from './UpdatedViewDetails';
import sortScoreImg from '../../assets/images/sort-score-img.svg'
import PaginationComponent from '../PaginationComponent';
import { useDispatch, useSelector } from 'react-redux';
import { loadAssignedToSlaData, loadModuleFieldNames, loadSingleAssignedToSlaData, loadUpdateSlaData } from '../../redux/action';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import noDataFound from '../../assets/images/no-data-found.svg';
import SlaUpdatedValueFilterModal from './SlaUpdatedValueFilterModal';
import UpdatedValueSlaColumnFilterModal from './UpdatedValueSlaColumnFilterModal';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import UpdateScoreHistory from './UpdateScoreHistory';
import { useLocation } from 'react-router-dom';
import noModuleAccess from '../../assets/images/no-module-access.svg';
import UpdateSlaModal from './UpdateSlaModal';
import { formatDate } from '../DateTimeUtils';
import { Highlighter, Typeahead } from 'react-bootstrap-typeahead';

const columns = [
    { id: 'SLAID', label: 'SLA NO', align: 'left', minWidth: '100px' },
    { id: 'SLAType', label: 'TYPE', align: 'left', minWidth: '100px' },
    { id: 'CustomerName', label: 'COMPANY NAME', align: 'left', minWidth: '160px' },
    { id: 'StartDate/EndDate', label: 'START DATE / END DATE', align: 'left', minWidth: '250px' },
    { id: 'TargetPercentage', label: 'TARGET %', align: 'left', minWidth: '120px' },
    // { id: 'AssignedTo', label: 'ASSIGNED TO', align: 'left', minWidth: '140px' },
    { id: 'AssignToUser', label: 'ASSIGNED TO USER', align: 'left', minWidth: '250px' },
    { id: 'TargetValue', label: 'TARGET VALUE', align: 'left', minWidth: '150px' },
    // { id: 'actualValue', label: 'ACTUAL VALUE', align: 'left', minWidth: '150px' },
    // { id: 'ReportedOn', label: 'REPORT DATE', align: 'left', minWidth: '150px' },
    { id: 'AchievedPercentage', label: 'ACHIEVED %', align: 'left', minWidth: '130px' },
    { id: 'DepartmentName', label: 'DEPARTMENT', align: 'left', minWidth: '200px' },
    { id: 'AssignedScore', label: 'ASSIGNED SCORE', align: 'left', minWidth: '160px' },
    { id: 'Status', label: 'STATUS', align: 'left', minWidth: '150px' },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const SortableHead = SortableContainer(({ children }) => {
    return (
        <TableHead>
            <TableRow>{children}</TableRow>
        </TableHead>
    );
});

const SortableCell = SortableElement(({ value }) => {
    return <TableCell>{value}</TableCell>;
});

const sortScoreOptions = [
    { value: "All", label: "All" },
    { value: "Below <40%", label: "Below <40%" },
    { value: "40-70%", label: "40-70%" },
    { value: "Above >70%", label: "Above >70%" },
]
const customStyles = {
    option: (provided, state) => {
        let color;
        switch (state.data.label) {
            case 'Below <40%':
                color = 'rgba(255, 94, 94, 1)';
                break;
            case '40-70%':
                color = 'rgba(240, 207, 43, 1)';
                break;
            case 'Above >70%':
                color = 'rgba(58, 201, 119, 1)';
                break;
            default:
                color = 'rgba(52, 58, 64, 1)';
        }
        return {
            ...provided,
            color,
            cursor: 'pointer',
        };
    }
};
const IndicatorSeparator = () => null;
const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={sortScoreImg} alt="Indicator" style={{ width: '20px', height: '20px' }} />
        </components.DropdownIndicator>
    );
};
const UpdatedValueTable = ({ assignedToSlaData, loading, setLoading, updatedSlaDatas, updtedSearchText, setUpdatedSearchText, setUpdatedSearchParams, setUpdatedSearchQuery, assignedToSlaDatas }) => {

    let dispatch = useDispatch();
    let location = useLocation();
    // const { updateSlaData = [] } = useSelector((state) => state.data);
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const DateFormat = signInDetails[0]?.DateFormat;
    const CompanyID = signInDetails[0]?.CompanyID;
    const SignInType = signInDetails[0]?.SignInType;
    const PreviousSuperAdminSignInType = sessionStorage.getItem('PreviousSuperAdminSignInType');

    const { singleAssignedToSlaData } = useSelector((state) => state.data);
    const { updateSlaData } = useSelector((state) => state.data);
    const { getModuleFieldsNames } = useSelector((state) => state.data);
    // const { modulePermissions } = useSelector((state) => state.data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];
    const [moduleData, setModuleData] = useState(null);

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;

    // useEffect(() => {
    //     if (moduleId && storedModulePermissions.length) {
    //         // Find the module data using the moduleId
    //         const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
    //         setModuleData(module);
    //     }
    // }, [storedModulePermissions, moduleId]);

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Loop through storedModulePermissions and nested MainModules and SubModules to find the matching ModuleID
            let foundModule = null;

            outerLoop:
            for (const sidebarMenu of storedModulePermissions) {
                for (const mainModule of sidebarMenu.MainModules) {
                    if (mainModule.SubModules && mainModule.SubModules.length > 0) {
                        const subModule = mainModule.SubModules.find(sub => sub.ModuleID === moduleId);
                        if (subModule) {
                            foundModule = subModule;
                            break outerLoop;
                        }
                    }
                }
            }

            setModuleData(foundModule);
        }
    }, [storedModulePermissions, moduleId]);

    const getStoredColumnsOrder = () => {
        const savedOrder = localStorage.getItem('updatedValueslaColumnsOrder');
        return savedOrder ? JSON.parse(savedOrder) : columns.map((col) => col.id);
    };

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);

    // Pagination state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
    const [paginatedData, setPaginatedData] = useState([]);
    const [columnsOrder, setColumnsOrder] = useState(getStoredColumnsOrder());
    const [selectedColumns, setSelectedColumns] = useState([
        "SLA NO", "TYPE", "COMPANY NAME", "START DATE / END DATE", "TARGET %", "ASSIGNED TO USER", "TARGET VALUE", "REPORT DATE", "ACHIEVED %", "DEPARTMENT", "ASSIGNED TO", "ASSIGNED SCORE", "STATUS", "ACTION"
    ]);
    const [selected, setSelected] = useState([]);
    // const [loading, setLoading] = useState(true);

    const renderCellValue = (customer, column) => {
        const value = customer[column.id];
        const valueType = customer.ValueType;

        // Fields that can vary based on ValueType
        const conditionalFields = ["BaseLine", "TargetValue", "TargetPercentage"];
        if (conditionalFields.includes(column.id)) {
            if (valueType === "Date" && value) {
                return formatDate(value);
            } else if (valueType === "Percentage" && value !== null && value !== undefined) {
                return `${value}%`;
            } else if (typeof value === "number") {
                return value.toLocaleString(); // optional number formatting
            }
            return value ?? "-";
        }

        // Special field to show StartDate / EndDate
        if (column.id === "StartDate/EndDate") {
            return `${formatDate(customer.StartDate)} / ${formatDate(customer.EndDate)}`;
        }

        // if (column.id === "ReportedOn") {
        //     return formatDate(customer.ReportedOn);
        // }

        // General formatting for StartDate and EndDate
        const alwaysDateFields = ["StartDate", "EndDate"];
        if (alwaysDateFields.includes(column.id)) {
            return formatDate(value);
        }

        return value ?? "-";
    };

    // Get selected columns (based on `selectedColumns` prop)
    const filteredColumns = columns.filter((column) =>
        selectedColumns.includes(column.label)
    );

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    // const updatedSlaDatas = () => {
    //     dispatch(loadUpdateSlaData(setLoading));
    // }
    // useEffect(() => {
    //     updatedSlaDatas();
    // }, []);

    const onReorderEnd = ({ oldIndex, newIndex }) => {
        const newOrder = Array.from(columnsOrder);
        const [moved] = newOrder.splice(oldIndex, 1);
        newOrder.splice(newIndex, 0, moved);
        setColumnsOrder(newOrder);
        localStorage.setItem('updatedValueslaColumnsOrder', JSON.stringify(newOrder)); // Store new order
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = assignedToSlaData.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [assignedToSlaData, order, orderBy]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showUpdatedViewModal, setShowUpdatedViewModal] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showUpdatedViewHistoryModal, setShowUpdatedViewHistoryModal] = useState(false);
    const [showScoreModal, setShowScoreModal] = useState(false);
    const [clickedCell, setClickedCell] = useState({ rowId: null, columnId: null }); // Track clicked cell
    const [slaId, setSlaId] = useState("");

    useEffect(() => {
        if (fromDate && toDate) {
            // Format the dates using moment.js
            const formattedFromDate = moment(fromDate).format('DD-MMM-YYYY'); // e.g., 01-Jan-2025
            const formattedToDate = moment(toDate).format('DD-MMM-YYYY');     // e.g., 15-Jan-2025

            // Build the WHERE clause with formatted dates
            const whereClause = `CONVERT(DATE,SA.SLA_StartDate,101) >= CONVERT(DATE,'${formattedFromDate}',101) AND CONVERT(DATE,SA.SLA_EndDate,101) <= CONVERT(DATE,'${formattedToDate}',101)`;

            // Update the searchParams state with the final WHERE clause
            setUpdatedSearchParams(whereClause);
        } else {
            // Clear date filter if no dates are selected
            setUpdatedSearchParams('');
        }
    }, [fromDate, toDate]); // The dependencies include fromDate, toDate, and searchText

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = () => {
        setIsModalOpen(true);
        dispatch(loadModuleFieldNames(null, 6, null));
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleOpenViewModal = (slaID) => {
        setShowUpdatedViewModal(!showUpdatedViewModal)
        if (slaID) {
            dispatch(loadSingleAssignedToSlaData(slaID));
            setSlaId(slaID);
        } else {
            setSlaId("");
        }
    }

    const handleOpenViewHistoryModal = (slaID) => {
        setShowUpdatedViewHistoryModal(!showUpdatedViewHistoryModal)
        if (slaID) {
            dispatch(loadUpdateSlaData(setLoading, slaID));
            setSlaId(slaID);
        } else {
            setSlaId("");
        }
    }
    const handleOpenScoreModal = (slaID) => {
        setShowScoreModal(!showScoreModal)
        if (slaID) {
            dispatch(loadSingleAssignedToSlaData(slaID));
            setSlaId(slaID);
        } else {
            setSlaId("");
        }
    }

    const handleCloseViewModal = () => {
        setShowUpdatedViewModal(false)
    }

    const handleCloseViewHistoryModal = () => {
        setShowUpdatedViewHistoryModal(false)
    }
    const handleCloseScoreModal = () => {
        setShowScoreModal(false)
    }

    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    // Pagination logic
    useEffect(() => {
        const start = page * rowsPerPage; // Updated page logic to 0-based
        const end = start + rowsPerPage;
        setPaginatedData(sortedData.slice(start, end));
    }, [sortedData, page, rowsPerPage]);

    const handlePageChange = (newPage) => {
        setPage(newPage - 1); // Handle 1-based to 0-based page index for slicing
    };
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };


    // Search trigger function
    const handleSearchClick = () => {
        setUpdatedSearchQuery(updtedSearchText); // Set the search query only when the button is clicked
    };

    // Handle the search input change (when selecting an item from Typeahead)
    const handleSearchChange = (selected) => {
        const query = selected.length ? selected[0] : ''; // Get the selected query or an empty string
        const selectedSlaId = query.SLAID;
        setUpdatedSearchQuery(selectedSlaId); // Update searchQuery
        // setSearchText(query); // Update searchText
        setSelected(selected);
    };

    const handleClearFilters = () => {
        setUpdatedSearchText("");
        setUpdatedSearchQuery("");
        setFromDate(null);
        setToDate(null);
        updatedSlaDatas();
        setSelected([]);
    }

    const processedAssinedToData = useMemo(() => {
        return assignedToSlaData.map(item => {
            const assignToNames = Array.isArray(item.AssignToUser)
                ? [...new Set(item.AssignToUser.map(u => u.UserName))].join(', ')
                : '';

            return {
                ...item,
                SLAID: String(item.SLAID || 'N/A'),
                SLAType: String(item.SLAType || ''),
                SLACategoryName: String(item.SLACategoryName || ''),
                CustomerName: String(item.CustomerName || ''),
                AssignToUser: assignToNames, // 💡 New field for display and search
            };
        });
    }, [assignedToSlaData]);

    return (
        <>
            <Row className='customermanagement-btns-container'>
                <Col md={2} className='customermanagement-backbtn-div'>
                    <span>Service Level Agreement</span>
                </Col>
                <Col md={10} className='customermanagement-search-filter'>
                    <div className='customermanagement-header-btns filter-btn'>
                        <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                        {showFilterMenu && (
                            <Dropdown.Menu show className='filter-dropdown-options'>
                                <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                    <img src={columnFilter} alt="Column Filter" />&nbsp;&nbsp;
                                    Column Filter
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                    <img src={valueFilter} alt="Value Filter" />&nbsp;&nbsp;
                                    Value Filter
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        )}
                    </div>
                    <Col md={3} className='filters-col'>
                        <div className='customermanagement-search'>
                            {/* <Form.Control
                                type="search"
                                placeholder='Search'
                                value={updtedSearchText}
                                onChange={(e) => setUpdatedSearchText(e.target.value)}
                            /> */}
                            <Typeahead
                                id="search-typeahead"
                                className='typeahead-search'
                                onChange={handleSearchChange}
                                options={processedAssinedToData}
                                labelKey="SLAType" // We are using a string (the company name), so we just use the string directly
                                filterBy={['SLAID', 'SLAType', 'SLACategoryName', 'CustomerName', 'AssignToUser']}
                                placeholder="Search SLA"
                                selected={selected}
                                value={updtedSearchText}
                                onInputChange={(input) => setUpdatedSearchText(input)} // Update searchText with typed value
                                minLength={1} // Minimum characters before suggestions appear
                                autoFocus={false} // Prevent auto focusing on input
                                renderMenu={(results, menuProps) => {
                                    // ✅ Hide table if an item is selected
                                    if (selected.length > 0 || !results.length) {
                                        return null;
                                    }

                                    return (
                                        <div {...menuProps} className='typeahead-search-options-table'>
                                            <table className="table table-sm  mb-0">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th style={{ 'minWidth': '100px' }}>Sla Id</th>
                                                        <th style={{ 'minWidth': '120px' }}>Sla Type</th>
                                                        <th style={{ 'minWidth': '150px' }}>Sla Category</th>
                                                        <th style={{ 'minWidth': '250px' }}>Comapany</th>
                                                        <th style={{ 'minWidth': '200px' }}>Assign To User</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {results.map((option, index) => (
                                                        <tr key={option.SLAID} onClick={() => handleSearchChange([option])} style={{ cursor: 'pointer' }}>
                                                            <td><Highlighter search={updtedSearchText}>{option.SLAID}</Highlighter></td>
                                                            <td><Highlighter search={updtedSearchText}>{option.SLAType}</Highlighter></td>
                                                            <td><Highlighter search={updtedSearchText}>{option.SLACategoryName}</Highlighter></td>
                                                            <td><Highlighter search={updtedSearchText}>{option.CustomerName}</Highlighter></td>
                                                            <td><Highlighter search={updtedSearchText}>{option.AssignToUser}</Highlighter></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    );
                                }}
                            />
                            {/* <img src={searchIcon} alt="Search" className='p-2' onClick={handleSearchClick} /> */}
                        </div>
                    </Col>
                    {/* <Col md={2} className='filters-col'>
                        <Select
                            className="react-select-container complaint-status-select"
                            classNamePrefix="react-select"
                            placeholder="Sort Score"
                            options={sortScoreOptions}
                            style={{ width: "100%" }}
                            styles={customStyles}
                            components={{ DropdownIndicator, IndicatorSeparator }}
                        />
                    </Col> */}
                    <Col md={2} className='filters-col'>
                        <div className='calendar-container'>
                            <DatePicker
                                className="select from-date"
                                dateFormat="dd/MM/yyyy"
                                selectsStart
                                placeholderText='From'
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                maxDate={new Date()}
                                onChangeRaw={e => e.preventDefault()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"

                            />
                            <img src={calendar} alt="Calendar" />
                        </div>
                    </Col>
                    <Col md={2} className='filters-col'>
                        <div className='calendar-container'>
                            <DatePicker
                                className="select to-date"
                                dateFormat="dd/MM/yyyy"
                                selectsEnd
                                placeholderText='To'
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                // minDate={new Date()}
                                onChangeRaw={e => e.preventDefault()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                            />
                            <img src={calendar} alt="Calendar" />
                        </div>
                    </Col>
                    <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                    {/* {signInDetails[0].SignInType === "SuperAdmin" && <SbAddBtn btnName="Add SLA" onClickEffect={handleOpenModal} />} */}
                    {moduleData?.CanCreate === true && (SignInType === "SuperAdmin" || PreviousSuperAdminSignInType === "SuperAdmin") && <SbAddBtn btnName="Add" onClickEffect={handleOpenModal} />}
                </Col>
            </Row>
            <div className='customermanagement-table-div'>
                {moduleData?.CanView === true ? (
                    <>
                        <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                            <Table>
                                <SortableHead axis="x" onSortEnd={onReorderEnd}>
                                    {columnsOrder.map((columnId, index) => {
                                        const column = columns.find(col => col.id === columnId);
                                        if (!column) return null; // Skip if column doesn't exist

                                        // Only display columns that are in filteredColumns
                                        if (!filteredColumns.find(col => col.id === columnId)) {
                                            return null;
                                        }
                                        return (
                                            <SortableCell key={column.id} index={index} value={
                                                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', minWidth: column.minWidth }} className='table-header-div'>
                                                    {column.label}
                                                    {column.sortable !== false && (
                                                        <IconButton
                                                            size="small"
                                                            onClick={(event) => handleRequestSort(event, column.id)}
                                                        >
                                                            <img src={SortIcon} alt="Sort" />
                                                        </IconButton>
                                                    )}
                                                </div>
                                            } />
                                        );
                                    })}
                                </SortableHead>
                                <TableBody>
                                    {
                                        loading ? (
                                            [...Array(rowsPerPage)].map((_, index) => (
                                                <TableRow key={index}>
                                                    {columns.map((column) => (
                                                        <TableCell key={column.id} align={column.align}>
                                                            <Skeleton height={40} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))
                                        ) : paginatedData.length === 0 ? (
                                            // Display "No Data Found" row if no data is present in the paginated data
                                            <TableRow>
                                                <TableCell colSpan={columns.length} >
                                                    <img src={noDataFound} alt="" style={{ height: "250px", width: "280px" }} />
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            paginatedData.map((customer) => (
                                                <TableRow key={customer.id}>
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            className={clickedCell.rowId === customer.slaNo && clickedCell.columnId === column.id ? 'clicked-value' : ''}
                                                            onMouseDown={() => setClickedCell({ rowId: customer.slaNo, columnId: column.id })}
                                                            onMouseUp={() => setClickedCell({ rowId: null, columnId: null })}
                                                            onMouseLeave={() => setClickedCell({ rowId: null, columnId: null })}
                                                        >
                                                            {column.id === 'Status' ? (
                                                                <span
                                                                    className={`status-badge ${customer.Status === 'Completed' ? 'complete-status no-dropdown-badge' :
                                                                        customer.Status === 'In-Progress' ? 'inprogress-status no-dropdown-badge' :
                                                                            customer.Status === 'Hold' ? 'pending-status no-dropdown-badge' :
                                                                                customer.Status === 'Cancel' ? 'cancel-status no-dropdown-badge' :
                                                                                    ''
                                                                        }`}
                                                                >
                                                                    {customer.Status}
                                                                </span>
                                                            ) : column.id === 'AssignedScore' ? (
                                                                <span
                                                                    className={`status-badge ${customer.AssignedScore <= 1 ? 'cancel-status no-dropdown-badge' :
                                                                        customer.AssignedScore >= 2 && customer.AssignedScore <= 3 ? 'pending-status no-dropdown-badge' :
                                                                            customer.AssignedScore >= 4 && customer.AssignedScore <= 5 ? 'complete-status no-dropdown-badge' :
                                                                                ''
                                                                        }`}
                                                                >
                                                                    {customer.AssignedScore}
                                                                </span>
                                                            )
                                                                // : column.id === 'ReportedOn' ? (
                                                                //     moment(customer.ReportedOn).format(DateFormat)
                                                                // ) 
                                                                : column.id === 'action' ? (
                                                                    <SbActionDropdownButton
                                                                        options={[{ type: 'View' }, { type: 'ViewHistory' }, { type: 'UpdateScore' }]}
                                                                        openAddModal={() => { handleOpenModal(customer.SLAID) }}
                                                                        addBulkModel={() => { handleOpenViewModal(customer.SLAID) }}
                                                                        viewHistoryModal={() => { handleOpenViewHistoryModal(customer.SLAID) }}
                                                                        updateScoreModal={() => { handleOpenScoreModal(customer.SLAID) }}
                                                                        signInType={signInDetails[0].SignInType}
                                                                        moduleData={moduleData}
                                                                        AssignToUser={customer.AssignToUser}
                                                                        loggedInUserID={signInDetails[0]?.UserID}
                                                                    />
                                                                ) :
                                                                    // column.id === 'StartDate/EndDate' ? (
                                                                    //     // Format and display the StartDate and EndDate
                                                                    //     <>
                                                                    //         <span>
                                                                    //             {/* {moment(customer.StartDate).format(DateFormat)} /
                                                                    //             {moment(customer.EndDate).format(DateFormat)} */}
                                                                    //             {formatDate(customer.StartDate)} / {formatDate(customer.EndDate)}
                                                                    //         </span>
                                                                    //     </>
                                                                    // ) :
                                                                    (
                                                                        <span
                                                                            onClick={() => {
                                                                                setClickedCell({ rowId: customer.slaNo, columnId: column.id }); // Track clicked cell
                                                                                handleOpenValueFilterModal(); // Open modal
                                                                            }}
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                                                            {/* {customer[column.id] || "NA"} */}
                                                                            {/* {renderCellValue(customer, column)} */}
                                                                            {column.id === 'AssignToUser' && Array.isArray(customer.AssignToUser)
                                                                                ? [...new Set(customer.AssignToUser.map(user => user.UserName))].join(', ')
                                                                                : renderCellValue(customer, column)}
                                                                        </span>
                                                                    )}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            )))}
                                </TableBody>
                            </Table>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={() => setAnchorEl(null)}
                            >
                                <MenuItem onClick={() => handleSortOrderChange('asc')}>
                                    <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                                    Ascending to Descending
                                </MenuItem>
                                <MenuItem onClick={() => handleSortOrderChange('desc')}>
                                    <img src={descToAsc} alt="" />&nbsp;&nbsp;
                                    Descending to Ascending
                                </MenuItem>
                            </Menu>
                        </TableContainer>
                        {/* Use PaginationComponent */}
                        <PaginationComponent
                            totalItems={assignedToSlaData.length}
                            itemsPerPage={rowsPerPage}
                            onPageChange={handlePageChange}
                            onRowsPerPageChange={handleRowsPerPageChange}
                        />
                    </>
                ) : (
                    <div className='d-flex align-items-center justify-content-center p-3'>
                        <img src={noModuleAccess} alt="" />
                    </div>
                )}
                {isModalOpen && <AddSLA open={isModalOpen} handleClose={handleCloseModal} getModuleFieldsNames={getModuleFieldsNames} />}
                {showUpdatedViewModal && <UpdatedViewDetails
                    open={showUpdatedViewModal}
                    handleClose={handleCloseViewModal}
                    singleAssignedToSlaData={singleAssignedToSlaData}
                    assignedToSlaDatas={assignedToSlaDatas}
                    slaId={slaId}
                />}
                {/* {
                    showUpdatedViewModal && signInDetails[0].SignInType === "User"
                        ? <UpdateScoreHistory
                            open={showUpdatedViewHistoryModal}
                            handleClose={handleCloseViewHistoryModal}
                            singleAssignedToSlaData={singleAssignedToSlaData}
                            assignedToSlaDatas={assignedToSlaDatas}
                            slaId={slaId}
                            updateSlaData={updateSlaData}
                            loading={loading}
                        />
                        : <UpdatedViewDetails
                            open={showUpdatedViewModal}
                            handleClose={handleCloseViewModal}
                            singleAssignedToSlaData={singleAssignedToSlaData}
                            assignedToSlaDatas={assignedToSlaDatas}
                            slaId={slaId}
                        />
                } */}

                {showUpdatedViewHistoryModal && <UpdateScoreHistory
                    open={showUpdatedViewHistoryModal}
                    handleClose={handleCloseViewHistoryModal}
                    singleAssignedToSlaData={singleAssignedToSlaData}
                    assignedToSlaDatas={assignedToSlaDatas}
                    slaId={slaId}
                    updateSlaData={updateSlaData}
                    loading={loading}
                />}
                {showScoreModal && <UpdateSlaModal
                    open={showScoreModal}
                    handleClose={handleCloseScoreModal}
                    singleAssignedToSlaData={singleAssignedToSlaData}
                    assignedToSlaDatas={assignedToSlaDatas}
                    slaId={slaId}
                    updateSlaData={updateSlaData}
                    loading={loading}
                    updatedSlaDatas={updatedSlaDatas}
                />}

                {
                    showColumnFilterModal && (
                        <UpdatedValueSlaColumnFilterModal
                            showColumnFilterModal={showColumnFilterModal}
                            handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                            selectedColumns={selectedColumns}
                            handleSaveColumns={handleColumnSelectionChange}
                        />
                    )
                }
                {
                    showValueFilterModal && (
                        <SlaUpdatedValueFilterModal
                            showValueFilterModal={showValueFilterModal}
                            handleCloseValueFilterModal={handleCloseValueFilterModal}
                        />
                    )
                }
            </div>
        </>
    );
};

export default UpdatedValueTable;



